<template>
  <custom-select
    ref="select"
    class="guest-picker"
    v-model="formData.guests"
    :placeholder="placeholder"
    :options="options"
  />
</template>

<script>
import CustomSelect from '../CustomSelect'
import {
  GUESTS
} from '../../../helpers/constants'

export default {
  components: {
    CustomSelect,
  },
  inject: ['formData'],
  props: {
    placeholder: {
      type: String,
      default: () => 'Add guests'
    },
    options: {
      type: Array,
      default: () => GUESTS
    }
  },
  methods: {
    show () {
      this.$refs.select.show()
    }
  }
}
</script>